import React, { useState } from "react";
import styled from "styled-components";
import {
  AiFillEdit,
  AiOutlineCloseCircle,
  AiOutlineCheck,
} from "react-icons/ai";
import { profileAPI } from "API/profile";
import { useDispatch } from "react-redux";
import { successLogin } from "context/userSlice";
import { errorHandler } from "API/errorHandler";
import { Spinner } from "components/styles/smallComponents";
import { dataPasswords } from "./data";
import { dispatchNotification } from "utils/dispatchNotification";
import { Btn } from "pages/admin/auxiliaries/OverlayStyledComp";

export const FlexIt = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
`;
export const ContactoContainer = styled.div`
  border: 1px solid ${(props) => props.theme.border};
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: ${(props) => props.theme.secondaryBody};
`;
export const Header = styled.h2`
  font-size: inherit;
  border-bottom: 1px solid ${(props) => props.theme.border};
  padding: 10px;
`;
export const ContactInfo = styled.div`
  display: flex;
  overflow-x: hidden;
`;
export const Section = styled.form`
  padding: 10px;
  transition: 0.3s;
  flex-shrink: 0;
  width: 100%;
  transform: ${(props) =>
    props.editPwd ? "translateX(-100%)" : "translateX(0px)"};
  display: flex;
  flex-direction: column;
  gap: 7px;
  justify-content: space-between;
`;
export const Nombre = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  & h2 {
    font-size: calc(var(--fontSmall) + 0.1rem);
  }
`;
export const Email = styled(Nombre)`
  word-break: break-all;
`;
export const ReactIcon = styled.div`
  text-align: right;
  font-size: var(--fontMed);
  color: var(--mainBlue);
  cursor: pointer;
  transition: 0.3s;
  &:hover {
    transform: scale(1.005);
  }
  &.check {
    color: var(--mainGreen);
  }
  &.cancel {
    color: ${(props) => props.theme.red};
  }
`;
export const ChangePwd = styled.h2`
  cursor: pointer;
  font-size: inherit;
`;
export const Input = styled.input`
  &:focus::placeholder {
    color: rgb(175, 168, 175);
  }
  padding: 10px;
  font-size: calc(var(--fontSmall - 0.1rem));
  width: 100%;
  border-radius: 10px;
`;
export const Button = styled(Btn)`
  padding: 5px;
  width: calc(80px + var(--fontSmall));
  font-size: inherit;
`;

export function Contacto({ user }) {
  const [editName, setEditName] = useState(false);
  const [nombre, setNombre] = useState(user?.nombre);
  const [Indloading, setLoading] = useState(false);
  const [editPwd, setEditPwd] = useState(false);
  const dispatch = useDispatch();
  async function submitChangeName(e) {
    e.preventDefault();
    if (nombre === user?.nombre) {
      return setEditName(false);
    }
    try {
      setLoading(true);
      await profileAPI.editName({ ...user, nombre });
      dispatch(successLogin({ ...user, nombre }));
      //SHOW SUCCESS MESSAGE
      dispatchNotification(dispatch, "Se actualizó exitosamente el nombre.");
    } catch (error) {
      errorHandler(error, dispatch, "UPDATE USER NAME");
    } finally {
      setEditName(false);
      setLoading(false);
    }
  }
  /* ----------------CHANGE PASSWORD SECTION-------------------- */
  const pwdInitialState = {
    oldPwd: "",
    newPwd: "",
    confirmaPwd: "",
  };
  const [passwords, setPasswords] = useState(pwdInitialState);
  async function handlePwdEditSubmit(e) {
    e.preventDefault();
    try {
      setLoading(true);
      await profileAPI.editPwd(passwords);
      //SHOW SUCCESS MESSAGE
      dispatchNotification(dispatch, "Operación exitosa.");
      /* clean inputs + go back to original UI */
      setPasswords(pwdInitialState);
      setEditPwd((v) => !v);
    } catch (error) {
      errorHandler(error, dispatch, "UPDATE USER PASSWORD");
    } finally {
      setLoading(false);
    }
  }
  function handlePwdsChange({ target }) {
    setPasswords({ ...passwords, [target.name]: target.value });
  }
  return (
    <ContactoContainer>
      <Header>
        <FlexIt>Info personal {Indloading && <Spinner />}</FlexIt>
      </Header>
      <ContactInfo>
        {/* -------------TEMPLATE P/NOMBRE Y A FUTURO MAIL--------------------- */}
        {/* me di cta q si apretaba ENTER luego de tipear el form enviaba la info, asi q le puse onSubmit event aca tmb */}
        <Section editPwd={editPwd} onSubmit={submitChangeName}>
          <Nombre>
            <FlexIt>
              <h2>Nombre</h2>
              {editName ? (
                <FlexIt>
                  <ReactIcon className="cancel">
                    <AiOutlineCloseCircle
                      onClick={() => setEditName((v) => !v)}
                    />
                  </ReactIcon>
                  <ReactIcon className="check">
                    <AiOutlineCheck onClick={submitChangeName} />
                  </ReactIcon>
                </FlexIt>
              ) : (
                <ReactIcon onClick={() => setEditName((v) => !v)}>
                  <AiFillEdit />
                </ReactIcon>
              )}
            </FlexIt>

            {editName ? (
              <Input
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                autoFocus
              />
            ) : (
              user?.nombre
            )}
          </Nombre>
          <Email>
            <FlexIt>
              <h2>Email</h2>
              {/*  <ReactIcon>
                <AiFillEdit />
              </ReactIcon> */}
            </FlexIt>

            {user?.emailUsuario}
          </Email>
          <ChangePwd onClick={() => setEditPwd((v) => !v)}>
            Cambiar contraseña
          </ChangePwd>
        </Section>
        {/* -------------TEMPLATE P/EDITAR CONTRASEñA--------------------- */}
        <Section editPwd={editPwd} onSubmit={handlePwdEditSubmit}>
          <Nombre>
            <div>Escribe tu vieja y tu nueva contraseña.</div>
            {dataPasswords.map((i) => {
              const { id, placeholder } = i;
              return (
                <Input
                  key={id}
                  type="password"
                  value={passwords[id]}
                  name={id}
                  onChange={handlePwdsChange}
                  placeholder={placeholder}
                  autoComplete="off"
                />
              );
            })}

            <FlexIt>
              <Button
                danger
                type="button"
                onClick={() => setEditPwd((v) => !v)}
                disabled={Indloading}
              >
                Volver
              </Button>
              <Button onClick={handlePwdEditSubmit} disabled={Indloading}>
                Confirmar
              </Button>
            </FlexIt>
          </Nombre>
        </Section>
      </ContactInfo>
    </ContactoContainer>
  );
}
